// src/components/BookGraph2.js
import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, LabelList, Legend
} from 'recharts';

const BookGraph2 = ({ data }) => {
  // Generate mock data for the other lines
  const enhancedData = data.map(book => ({
    title: book.title,
    addToCart: book.engagements,
    coverView: Math.floor(Math.random() * 7),
    timeSpent: Math.floor(Math.random() * 5),
    showBio: Math.floor(Math.random() * 8),
  }));

  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer>
        <LineChart
          data={enhancedData}
          margin={{ top: 20, right: 30, left: 10, bottom: 30 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="title" angle={-15} textAnchor="end" interval={0} />
          <YAxis />
          <Tooltip />
          <Legend verticalAlign="top" height={36} />

          {/* Add to Cart */}
          <Line type="monotone" dataKey="addToCart" name="Add to Cart" stroke="#ff6384" strokeWidth={2} activeDot={{ r: 5 }}>
            <LabelList dataKey="addToCart" position="top" />
          </Line>

         {/* Cover of eBook (change strokeDasharray to solid) */}
	<Line type="monotone" dataKey="coverView" name="Cover of eBook" stroke="#36a2eb" strokeWidth={2}>
 	 <LabelList dataKey="coverView" position="top" />
	</Line>
          {/* Time Spent on eBook */}
          <Line type="monotone" dataKey="timeSpent" name="Time Spent" stroke="#ffce56" strokeWidth={2}>
            <LabelList dataKey="timeSpent" position="top" />
          </Line>

         {/* Show Bio (also remove dashed line) */}
	<Line type="monotone" dataKey="showBio" name="Show Bio" stroke="#4bc0c0" strokeWidth={2}>
 	 <LabelList dataKey="showBio" position="top" />
	</Line>

        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BookGraph2;
